// Payout-method-specific input field schemas.
// Each schema is an array of fields the user must fill to receive payment via that method.
export const PAYOUT_FIELDS = {
  paypal: [
    { key: "email_or_tag", label: "PayPal email or @PayPal.Me tag", placeholder: "you@example.com or paypal.me/yourtag", required: true },
  ],
  cashapp: [
    { key: "cashtag", label: "Cash App $Cashtag", placeholder: "$yourcashtag", required: true },
  ],
  zelle: [
    { key: "email_or_phone", label: "Zelle email or US phone number", placeholder: "you@example.com or +1 555 123 4567", required: true },
  ],
  venmo: [
    { key: "username", label: "Venmo @username", placeholder: "@yourusername", required: true },
  ],
  chime: [
    { key: "email_or_chimesign", label: "Chime email or $ChimeSign", placeholder: "you@example.com or $yourchimesign", required: true },
  ],
  applepay: [
    { key: "phone_or_email", label: "Apple Pay phone or email", placeholder: "+1 555 ... or you@example.com", required: true },
  ],
  googlepay: [
    { key: "phone_or_email", label: "Google Pay phone or email", placeholder: "+1 555 ... or you@example.com", required: true },
  ],
  bank: [
    { key: "account_holder", label: "Account holder name", placeholder: "Full legal name as on the account", required: true },
    { key: "account_number", label: "Account number or IBAN", placeholder: "Account # (US/CA) or IBAN (UK/AE)", required: true },
    { key: "routing_or_swift", label: "Routing number, Sort code or SWIFT/BIC", placeholder: "ABA routing (US), sort code (UK), SWIFT/BIC", required: true },
    { key: "bank_name", label: "Bank name", placeholder: "e.g. Chase Bank, Barclays, Emirates NBD", required: true },
  ],
  btc: [
    { key: "wallet_address", label: "Bitcoin (BTC) wallet address", placeholder: "bc1q... or 1... or 3...", required: true },
  ],
  interac: [
    { key: "email", label: "Interac e-Transfer email", placeholder: "you@example.com", required: true },
    { key: "security_question", label: "Security question (optional)", placeholder: "e.g. What is the brand?", required: false },
    { key: "security_answer", label: "Security answer (optional)", placeholder: "Answer to the question above", required: false },
  ],
  usdt_trc20: [
    { key: "wallet_address", label: "USDT TRC20 wallet address", placeholder: "T... (Tron network)", required: true },
  ],
  usdt_erc20: [
    { key: "wallet_address", label: "USDT ERC20 wallet address", placeholder: "0x... (Ethereum network)", required: true },
  ],
};

// Returns true if every required field for the method has been filled.
export function isPayoutDestinationComplete(methodId, destination) {
  const schema = PAYOUT_FIELDS[methodId] || [];
  if (schema.length === 0) return true;
  if (!destination || typeof destination !== "object") return false;
  return schema
    .filter((f) => f.required)
    .every((f) => destination[f.key] && String(destination[f.key]).trim().length > 0);
}

// Human-readable label for a payout-destination dict, used in admin / dashboard views.
export function formatPayoutDestination(methodId, dest) {
  if (!dest) return "—";
  if (typeof dest === "string") return dest; // legacy txs
  const schema = PAYOUT_FIELDS[methodId];
  if (!schema) return Object.entries(dest).map(([k, v]) => `${k}: ${v}`).join(" · ");
  return schema
    .map((f) => (dest[f.key] ? `${f.label.replace(/\s*\(optional\)/i, "")}: ${dest[f.key]}` : null))
    .filter(Boolean)
    .join(" · ");
}
